import { useChainId, useConfig } from 'wagmi'

//TODO: shouldn't this use useConnection and our networks config?
export function useBlockExplorerBaseUrl() {
  const chainId = useChainId()
  const { chains } = useConfig()
  return chains.find((c) => c.id === chainId)?.blockExplorers?.default?.url
}
